import { CommonResponse, TargetMenu } from 'models';
import axiosClient from 'utils/axiosClient';
import {
  MenuOrderQuantityLimitAddPayload,
  MenuOrderQuantityLimitDeletePayload,
  MenuOrderQuantityLimitGetListPayload,
} from '../models';

const url = '/menu-order-quantity-limit';

export const menuOrderQuantityLimitService = {
  getList(payload: MenuOrderQuantityLimitGetListPayload): Promise<CommonResponse<TargetMenu[]>> {
    const params = new URLSearchParams();

    // Add query parameters if values are non-empty
    if (payload.limit_type) {
      params.append('limit_type', payload.limit_type.toString());
    }

    const queryString = params.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;

    return axiosClient.get(fullUrl);
  },

  add(payload: MenuOrderQuantityLimitAddPayload[]): Promise<CommonResponse<any>> {
    return axiosClient.post(url, payload);
  },

  delete(payload: MenuOrderQuantityLimitDeletePayload[]): Promise<CommonResponse<any>> {
    return axiosClient.delete(url, { data: payload });
  },
};
